// initial state
const state = {
  options: {
    status: [
      {label: '是', value: 0},
      {label: '否', value: 1},
    ],
  },
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {}

export const platformAndroidapkTest = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/platform-androidapk-test/platform-androidapk-test.store.js